/**
 * Which build a docs page is, and a fetch of the site's own static files pinned to it: shared by the routes'
 * lazy fields (LazyRouteBody) and the page menu (PageMenu), which every docs page carries, so neither pulls
 * in the other.
 */

/** The build this page is (next.config.ts inlines it): a group's JSON from another build is not this page's. */
export const PAGE_BUILD = (): string | null =>
  process.env.BUILD_COMMIT_SHA || null;

/**
 * Where to fetch a static file of the site: pinned to this page's deployment where the build has one
 * (production's NEXT_DEPLOYMENT_ID, as Next pins its own requests), so a tab opened before a deploy reads its
 * own build's.
 */
export function pinned(src: string): string {
  const deployment = process.env.NEXT_DEPLOYMENT_ID;
  return deployment ? `${src}?dpl=${encodeURIComponent(deployment)}` : src;
}
